module.exports = __webpack_public_path__ + "img/banner1.ffc6f51.jpg";